import { atlasRoutes } from "@/app/router/routes";
import { LookupByUuidForm } from "@/components/forms/lookup-by-uuid-form";
import { FC } from "react";
import { useNavigate } from "react-router";

export const SyncModelEventsRootPage: FC = () => {
  const navigate = useNavigate();

  return (
    <div>
      <h1>SyncModelEventsRootPage</h1>

      <LookupByUuidForm
        onSubmit={uuid =>
          navigate(atlasRoutes.syncModelEventsView({ params: { syncModelEventId: uuid } }).path)
        }
      />
    </div>
  );
};
